import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

// Components
import Toast from "components/WMS/Toast";

// Assets
import ValidatedIcon from "assets/img/validated.svg";

InTrolleyToast.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired
};

function InTrolleyToast({isOpen, handleClose, isMulti = false, ...props}) {
    const [subtitle, setSubtitle] = useState(isMulti ? "wms.myPickingMissions.product.scanned.subtitle.multi" : "wms.myPickingMissions.product.scanned.subtitle.mono")
    const icon = (
        <img
            src={ValidatedIcon}
            alt={props.intl.formatMessage({id: 'wms.myPickingMissions.product.scanned.title'})}
            style={{width: '20px', height: '20px'}}
        />
    );

    return (
        <Toast
            icon={icon}
            title={<FormattedMessage id={'wms.myPickingMissions.product.scanned.title'} />}
            subtitle={<FormattedMessage id={subtitle} />}
            open={isOpen}
            handleClose={handleClose}
        />
    );
}

export default injectIntl(InTrolleyToast);
